const AbiTradePartnerApiUrls = {
  GET: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/trade-partner/get`,
  POST: `${process.env.REACT_APP_USER_ABI_URL}/abi/trade-partner/create`,
  PUT: `${process.env.REACT_APP_USER_ABI_URL}/abi/trade-partner/update`,
  DELETE: `${process.env.REACT_APP_USER_ABI_URL}/abi/trade-partner/delete`,
  CLONE: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/trade-partner/clone`,
};

export default AbiTradePartnerApiUrls
